var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;opacity:0.5;fill:#F0DF64;}\n\t.st3{fill:#F3F3F3;stroke:#1E344A;stroke-width:2.7283;stroke-miterlimit:10;}\n\t.st4{fill:#1E344A;}\n\t.st5{fill:#D8D8D8;}\n\t.st6{opacity:0.5;fill:#A6D97D;}\n\t.st7{fill:#F5F5F5;stroke:#4D4B4C;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#4D4B4C;stroke-width:0.9574;stroke-miterlimit:10;}\n\t.st9{fill:#66B4BF;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st10{fill:#EED58C;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#4D4B4C;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#4D4B4C;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st14{fill:#D65555;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st15{fill:#A6D97D;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st16{opacity:0.2;fill:#66B4BF;}\n\t.st17{opacity:0.2;fill:#264366;}\n\t.st18{fill:#D8D8D8;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st19{fill:#9B9B9A;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st20{opacity:0.29;fill:#F5F5F5;}\n\t.st21{fill:#F5F5F5;}\n\t.st22{fill:#C4C4C4;}\n\t.st23{fill:#E6AF41;stroke:#1E344A;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.3,
    y: -2,
    className: "st1",
    width: 1924.5,
    height: 1083.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.8,1080.7V881c0,0,165.3,25.8,181.7,104.3s70.3,15.2,120.7,21.1c50.4,5.9,63.3,74.4,63.3,74.4 S-0.3,1079.6,0.8,1080.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1918.6,616.7V185.3c0,0-131,29.4-140,140c-9,110.7,56.5,149.1,58.7,198.8c2.3,49.7-42.9,61-27.1,124.2 s108.4,117.5,108.4,117.5V616.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1725.5,1056 170,1056 299.3,934.7 1545.9,934.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 1055.8,
    className: "st4",
    width: 1556.8,
    height: 26.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 811.1,
    cy: 1013.4,
    rx: 66,
    ry: 16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 678.4,
    cy: 978.9,
    rx: 25.4,
    ry: 11.1
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 661.9,
    cy: 378.1,
    rx: 359.4,
    ry: 364.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M301.7,984.7l56.3-38.5h234.2l2,2.1c7.7,8.1,9.1,20.5,3.4,30.1l0,0L541,1021"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M583.8,996.7c-1.2,0-2.1-1-2.1-2.2c0-1.2,1-2.2,2.1-2.2c11.8,0,21.4-9.8,21.4-21.8c0-12-9.6-21.8-21.4-21.8 c-1.5,0-3,0.2-4.5,0.5c-1.1,0.2-2.3-0.5-2.5-1.7c-0.2-1.2,0.5-2.3,1.7-2.6c1.7-0.4,3.5-0.6,5.3-0.6c14.2,0,25.7,11.7,25.7,26.1 C609.5,985,598,996.7,583.8,996.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M530.6,1023.2h-229l1.1-1.6c7.9-11.2,7.4-26.3-1.1-36.9l0,0h229c10.5,0,19,8.6,19,19.3l0,0 C549.6,1014.6,541.1,1023.2,530.6,1023.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M565.2,1010.7c-1.2,0-2.1-1-2.1-2.2c0-1.2,1-2.2,2.1-2.2c11.8,0,21.4-9.8,21.4-21.8 c0-12-9.6-21.8-21.4-21.8c-1.5,0-3,0.2-4.5,0.5c-1.1,0.2-2.3-0.5-2.5-1.7c-0.2-1.2,0.5-2.3,1.7-2.6c1.7-0.4,3.5-0.6,5.3-0.6 c14.2,0,25.7,11.7,25.7,26.1S579.4,1010.7,565.2,1010.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M543.4,1024.1c-1.2,0-2.1-1-2.1-2.2c0-1.2,1-2.2,2.1-2.2c11.8,0,21.4-9.8,21.4-21.8 c0-12-9.6-21.8-21.4-21.8c-1.5,0-3,0.2-4.5,0.5c-1.1,0.2-2.3-0.5-2.5-1.7c-0.2-1.2,0.5-2.3,1.7-2.6c1.7-0.4,3.5-0.6,5.3-0.6 c14.2,0,25.7,11.7,25.7,26.1S557.6,1024.1,543.4,1024.1z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.9,
    y1: 992.5,
    x2: 544.8,
    y2: 992.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.9,
    y1: 1000,
    x2: 548.4,
    y2: 1000
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.9,
    y1: 1007.5,
    x2: 549.2,
    y2: 1007.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 306.9,
    y1: 1015,
    x2: 544.8,
    y2: 1015
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M886.4,428.1c0,0-36.3,3.3-64.6,10.7c-28.3,7.4-80,33.6-80,33.6l23.4,176.2L779,933.8h437.7l38-269.7 l4-214.8c0,0-53.3-9.8-87.2-13.9c-33.9-4.1-54.1-2.5-54.1-2.5L886.4,428.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1069.7,380.5c0,0,8.1,25.4,21,38.5c12.9,13.1,26.7,13.9,26.7,13.9s-22.6,91.8-124.4,90.2 c-89.7-1.4-106.6-95.1-106.6-95.1s29.1,0.8,38-13.9c8.9-14.8,5.7-32,5.7-32L1069.7,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M875.1,428.9c0,0,1.6,61.5,59.8,95.1c58.1,33.6,131.3,8.9,153.4-11.5c34.7-32,42.8-80.3,42.8-80.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M924.4,414.1c0,0,26.7,50.8,46,59c19.4,8.2,58.1,8.2,72.7-1.6c14.5-9.8,40.4-59,40.4-59l-13.7-32L930,382.2 c0,0,1.6,10.7,0,18.9C928.4,409.2,924.4,414.1,924.4,414.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 877.5,
    y1: 444.5,
    x2: 889.6,
    y2: 440.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 882.4,
    y1: 459.2,
    x2: 894.5,
    y2: 454.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 890.4,
    y1: 480.5,
    x2: 905,
    y2: 474
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 906.6,
    y1: 497.7,
    x2: 916.3,
    y2: 491.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 920.3,
    y1: 515,
    x2: 930,
    y2: 505.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 937.3,
    y1: 524,
    x2: 947,
    y2: 514.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 963.1,
    y1: 535.5,
    x2: 968.8,
    y2: 521.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 984.1,
    y1: 539.5,
    x2: 984.9,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1010,
    y1: 540.4,
    x2: 1008.3,
    y2: 524.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1031.8,
    y1: 537.9,
    x2: 1026.1,
    y2: 520.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1056,
    y1: 531.4,
    x2: 1049.5,
    y2: 512.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1073,
    y1: 522.3,
    x2: 1063.3,
    y2: 505.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1089.1,
    y1: 510.9,
    x2: 1077.8,
    y2: 497.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1101.2,
    y1: 496.9,
    x2: 1089.1,
    y2: 486.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1110.1,
    y1: 485.4,
    x2: 1098.8,
    y2: 475.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1119,
    y1: 467.4,
    x2: 1107.7,
    y2: 460
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 1126.3,
    y1: 448.6,
    x2: 1111.7,
    y2: 446.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1258.7,449.4c0,0,54.1,39.3,81.6,87.7c27.5,48.4,51.7,100,51.7,100s-50.1,33.6-82.4,45.1 c-32.3,11.5-59.8,13.1-59.8,13.1s-6.5-73.8-4-133.6C1248.2,501.8,1258.7,449.4,1258.7,449.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M741.8,472.3c0,0,26.7,53.3,36.3,104.9c9.7,51.6-11.3,95.1-11.3,95.1l-51.7,96.7c0,0-17.8-32-48.5-50.8 c-30.7-18.9-69.5-21.3-69.5-21.3s32.3-90.2,61.4-141C687.7,505.1,741.8,472.3,741.8,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M715.2,769.1c0,0-38,68.9-65.4,99.2c-27.5,30.3-62.2,46.7-62.2,46.7s20.2-27.1,8.1-66.4 c-12.1-39.3-44.4-53.3-44.4-53.3l46-98.4c0,0,45.2,4.1,69.5,21.3C691,735.5,715.2,769.1,715.2,769.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M447.9,922.1c0,0,48.5,9.3,85.1,5.5c36.6-3.8,54.6-12.6,54.6-12.6s18.8-33.7,8.1-66.4 c-13.2-40.2-44.4-53.3-44.4-53.3s-21.5,1.6-38.2,13.1c-16.7,11.5-56,25.1-72.1,24.6c-16.2-0.5-25.8-4.4-25.8-4.4 s-6.5,41.5,4.8,61.2C431.2,909.5,447.9,922.1,447.9,922.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M446.8,843.4c0,0,24.8-9.3,33.9-6.6c9.2,2.7,14,19.1,15.6,28.4c1.6,9.3,14,32.8,10.8,36.1 c-3.2,3.3-11.3,2.2-18.8-2.2c-7.5-4.4-14.5-21.9-14.5-21.9L446.8,843.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M356.7,752.9l141.8,188.9l22.1,10.9l-7-21.9L371.8,741.2c-3-4-8.5-5-12.7-2.3v0 C354.5,741.9,353.3,748.4,356.7,752.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M603.7,687.1c0,0,38-3.3,69.5,18c31.5,21.3,46,50.8,46,50.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M408.6,819.9c0,0-14-1.1-19.9,1.1c-5.9,2.2-10.2,10.4-10.2,10.4s-17.2,9.8-21,15.8 c-3.8,6-5.4,13.7-5.4,13.7s-5.4,9.3-5.4,21.9s1.1,24.6,1.1,24.6l9.7,13.7c0,0-4.8,9.3-1.6,20.2c3.2,10.9-0.5,12,14,20.8 c14.5,8.7,43.6,15.3,55.5,14.8c11.8-0.5,61.4-15.8,63.5-20.2c2.2-4.4-2.2-11.5-2.2-11.5s4.8-1.1,5.4-7.7 c0.5-6.6-6.5-15.3-6.5-15.3s4.8-4.9,4.8-13.1c0-8.2-12.9-19.1-12.9-19.1l-14-13.1L408.6,819.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M485.5,922.1c0,0-71.6-28.4-82.9-44.8s-24.2-45.9-24.2-45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M486.6,945c0,0-75.1-15.3-87.2-23.5c-12.1-8.2-47.4-60.7-47.4-60.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M475.3,943.7c0,0-42,15.6-61.4,9.8c-19.4-5.7-56.5-32.5-56.5-32.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M875.9,201.8c0,0,8.9,116.4,28.3,163.1c19.4,46.7,58.1,88.1,70.3,91.8c12.1,3.7,54.1,4.9,66.2-7.4 c12.1-12.3,52.5-54.5,67-124.6s9.3-138.9,9.3-138.9l-78.7-73.8l-90.9,6.1l-30.3,27.1L875.9,201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M880.7,251.8c0,0-24.2-56.6-18.6-98.4c5.7-41.8,33.1-83.6,33.1-83.6l0.8,20.5c0,0,33.1-32,71.1-46.7 c38-14.8,77.5-17.2,77.5-17.2l-14.5,18.9c0,0,34.7,13.1,59,22.1c24.2,9,66.2,5.7,64.6,13.1c-1.6,7.4-21.8,13.1-21.8,13.1 s12.1,33.6,22.6,45.1c10.5,11.5,7.3,28.7,0.8,27.1c-6.5-1.6-25,3.3-25,3.3s26.7,20.5,16.2,25.4c-10.5,4.9-113.9,1.6-113.9,1.6 s20.2,11.5,12.1,13.9c-8.1,2.5-80,4.9-105.8-4.9c-25.8-9.8-42.8-14.8-42.8-14.8L880.7,251.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1104.5,195.3 1117.4,263.3 1138.4,189.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M876.7,211.7c0,0-9.7-3.3-22.6,0c-12.9,3.3-24.2,13.9-24.2,13.9L846,346.1c0,0,17,10.7,29.1,9 c12.1-1.6,23.4-6.6,23.4-6.6L876.7,211.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "841.5,319.4 823.1,321.6 816.6,265.4 835,263.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1125.7,211.7c0,0,9.7-3.3,22.6,0c12.9,3.3,24.2,13.9,24.2,13.9l-16.2,120.5c0,0-17,10.7-29.1,9 s-23.4-6.6-23.4-6.6L1125.7,211.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "1160.9,319.4 1179.3,321.6 1185.8,265.4 1167.4,263.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M854.1,211.7c3.7,0,7.3,0,10.6,0C870,139.9,929,83.4,1001.1,83.4c71.4,0,130.1,55.6,136.2,126.5 c3.5-0.1,7.4,0.4,11,1.8c1.3,0.5,2.5,1,3.6,1.5c-3.4-81.6-69.7-146.6-150.9-146.6c-80.9,0-146.9,64.5-150.8,145.6 C851.5,211.9,852.8,211.7,854.1,211.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "1007.8,335.7 1018,370.1 991.7,366.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M949.7,375.6c0,0,4.8,13.7,15.1,21.9c10.2,8.2,21.5,8.7,21.5,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M909.3,285.4c0,0,18.3-13.7,35-11.5c11.8,1.5,20.6,7.2,24.8,10.4c1.6,1.2,2.4,3.3,1.8,5.3l0,0 c-0.9,3.3-4.6,4.8-7.4,3c-4.2-2.6-10.6-5.8-19.2-7.3C928.1,282.7,909.3,285.4,909.3,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M915.2,311.7c0,0,15.5-7.7,28-6c19.9,2.7,28,14.8,28,14.8s-11.8,7.1-30.7,2.7 C921.7,318.8,915.2,311.7,915.2,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M929.1,318.7c0,0,1.9-5.5,8.1-9c5.6-3.2,10.9-2.3,10.9-2.3s4.3,2.6,8.4,5.9c4.1,3.4,7.5,8.8,7.5,8.8 s-6.9,2.9-18.2,1.5S929.1,318.7,929.1,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1092.3,285.4c0,0-18.3-13.7-35-11.5c-11.8,1.5-20.6,7.2-24.8,10.4c-1.6,1.2-2.4,3.3-1.8,5.3l0,0 c0.9,3.3,4.6,4.8,7.4,3c4.2-2.6,10.6-5.8,19.2-7.3C1073.5,282.7,1092.3,285.4,1092.3,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1086.4,311.7c0,0-15.5-7.7-28-6c-19.9,2.7-28,14.8-28,14.8s11.8,7.1,30.7,2.7 C1080,318.8,1086.4,311.7,1086.4,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1072.4,319.1c0,0-1.7-5.6-7.8-9.3c-5.5-3.3-10.9-2.6-10.9-2.6s-4.3,2.4-8.6,5.7c-4.2,3.2-7.7,8.6-7.7,8.6 s6.9,3,18.1,2C1066.8,322.5,1072.4,319.1,1072.4,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M963.9,189.5c26.5,7.2,46,7.4,46,7.4l-9.7-17.2c0,0,34.7,2.5,63-1.6c28.3-4.1,35.5-10.7,35.5-10.7 s-33.9,0-64.6-1.6c-30.7-1.6-59.8-12.3-59.8-12.3l10.5,26.2c0,0-18.6,0.8-36.3-6.6c-17.8-7.4-40.4-21.3-40.4-21.3 S921.9,178,963.9,189.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M779,933.8l92.1-0.8c0,0,71.1-29.5,54.9-96.7c-16.2-67.2-67.8,4.9-87.2-52.5 c-19.4-57.4,30.7-78.7,3.2-109.8c-27.5-31.1-75.1-1.6-75.1-1.6L779,933.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M597.3,696.9c0,0,35.1-105.3,67.8-150.8c32.7-45.5,76.7-73.8,76.7-73.8S739,530.1,716,573.2 c-23,43-49.7,16-59.4,45.5c-9.7,29.5,24.2,29.5,8.5,55.3C649.4,699.8,597.3,696.9,597.3,696.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1249.8,695.3c0,0-5.7-55.7-4.4-106.2c1.2-50.4,3.6-77.5,3.6-77.5s38.8,34.4,53.3,75 c14.5,40.6-26.7,33.2-15.7,52.9c10.9,19.7,46,33.2,46,33.2s-14.5,9.8-42.4,16C1262.3,694.9,1249.8,695.3,1249.8,695.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1561,592.8H1013c-14.2,0-25.7,11.7-25.7,26.1v366.2h577.9l21.4-364.6 C1587.5,605.5,1575.8,592.8,1561,592.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "987.3,985.1 928.4,932.2 926.8,917.4 986.5,971.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "986.5,971.5 926.8,917.4 987.3,917.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1412.6,592.8h141.2c16.7,0,29.9,14.3,28.8,31.2l-23.4,361c0,0-94.5-35.7-100.5-98.4 c-6.1-62.7,77.5-91,58.1-156.2c-19.4-65.2-76.3,6.1-121.1-36.9C1350.8,650.6,1412.6,592.8,1412.6,592.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 1290.2,
    cy: 800.6,
    rx: 42.4,
    ry: 43
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 1328.5,
    cy: 330.2,
    rx: 83.6,
    ry: 84.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 1394.5,
    cy: 131,
    rx: 63,
    ry: 63.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1291.5,
    y: 282.5,
    className: "st13",
    width: 73.9,
    height: 95.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1300.8,
    y1: 307.1,
    x2: 1355.7,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1300.8,
    y1: 317.3,
    x2: 1355.7,
    y2: 317.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1300.8,
    y1: 327.5,
    x2: 1355.7,
    y2: 327.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1300.8,
    y1: 337.8,
    x2: 1355.7,
    y2: 337.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1300.8,
    y1: 348,
    x2: 1355.7,
    y2: 348
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325.8,
    y: 357.9,
    className: "st22",
    width: 30.7,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1301,
    y: 290.7,
    className: "st22",
    width: 54.4,
    height: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1365.2,93.4 1368.6,100.3 1376.1,101.4 1370.6,106.8 1371.9,114.4 1365.2,110.8 1358.5,114.4  1359.8,106.8 1354.3,101.4 1361.9,100.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1365.2,120.5 1368.6,127.4 1376.1,128.5 1370.6,133.9 1371.9,141.5 1365.2,137.9 1358.5,141.5  1359.8,133.9 1354.3,128.5 1361.9,127.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1365.2,147.5 1368.6,154.4 1376.1,155.5 1370.6,160.9 1371.9,168.5 1365.2,164.9 1358.5,168.5  1359.8,160.9 1354.3,155.5 1361.9,154.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1385.4,
    y1: 106.3,
    x2: 1434.7,
    y2: 106.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1385.4,
    y1: 134.1,
    x2: 1434.7,
    y2: 134.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1385.4,
    y1: 162,
    x2: 1434.7,
    y2: 162
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 545.2,
    cy: 404.7,
    rx: 37.6,
    ry: 38.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 494.3,
    cy: 284.2,
    rx: 20.6,
    ry: 20.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.87e20cd61c1b4f09dd235a471637620d.svg";
export { ForwardRef as ReactComponent };